import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import { withApollo } from "react-apollo";
import { push } from 'connected-react-router';
import { Breadcrumb, Button } from 'antd';
import AntIcon from '../shared/components/AntIcon';
import { Link } from 'react-router-dom';

import PostForm from './components/PostForm';

import withGraphqlData from '../shared/components/withGraphqlData';
import { parseFormErrors } from '../shared/utils/form_errors';
import { PostDetailQuery, UpdatePostMutation, UpdateCommentMutation, DeleteCommentMutation, CreatePostTagMutation, DeletePostTagMutation } from './queries';

class EditPost extends Component {
  constructor(props) {
    super(props);

    this.state = { deleting: false, deleteError: null };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.deleteComment = this.deleteComment.bind(this);
    this.deletePostTag = this.deletePostTag.bind(this);
    this.createPostTag = this.createPostTag.bind(this);
  }

  handleSubmit({ hasStringPrice, ...newData }) {
    this.setState({ deleteError: null });
    const { client, postId, push, data } = this.props;

    const commentsList = Array.from(newData.comments)
    commentsList.forEach(comment => 
      client.mutate({ mutation: UpdateCommentMutation, variables: { id: comment._id, update: comment }, })
    )

    const oldTags = data.Post.tags.items
    oldTags.forEach(tag => {
      this.deletePostTag(tag.tag._id)
    })

    const newTags = newData.tags.items
    newTags.forEach(newTag => {
      this.createPostTag(newTag)
    })

    return client.mutate({ mutation: UpdatePostMutation, variables: { id: postId, update: newData }})
      .then(() => push('/posts'))
      .catch(parseFormErrors);
  }

  deleteComment(id) {
    const { client } = this.props;
    return client.mutate({ mutation: DeleteCommentMutation, variables: { id }})
  }

  deletePostTag(tagId) {
    const { client, postId } = this.props;
    client.mutate({ mutation: DeletePostTagMutation, variables: {update: {post: postId, tag: tagId}}})
  }

  createPostTag(tagId) {
    const { client, postId } = this.props;
    if (typeof(tagId) === "object") {
      client.mutate({ mutation: CreatePostTagMutation, variables: {record: {post: postId, tag: tagId.tag._id}}})
    } else {
      client.mutate({ mutation: CreatePostTagMutation, variables: {record: {post: postId, tag: tagId}}})
    }
  }

  handleDelete() {
    this.setState({ deleting: true, deleteError: null });
    const { client, postId, push } = this.props;
    return client.mutate({
      mutation: UpdatePostMutation,
      variables: { id: postId, update: { isDeleted: true, featured: false } },
    })
      .then(() => push('/posts'))
      .catch(error => this.setState({
        deleting: false, deleteError: error.message,
      }));
  }

  render() {
    const { role } = this.props.user;
    const { Post } = this.props.data;
    const modelTags = this.props.modelTags;
    const { deleting, deleteError } = this.state;

    const deleteButton = (
      <Button ghost disabled={deleting} loading={deleting} onClick={this.handleDelete} type="danger">
        <AntIcon type="delete" />Delete
      </Button>
    );

    const formPost = {
      ...Post,
      comments: Post.comments.items,
    };

    return (
      <div id="edit-post">
        <Breadcrumb>
          <Breadcrumb.Item><Link to="/posts">Posts</Link></Breadcrumb.Item>
          <Breadcrumb.Item>Edit Post</Breadcrumb.Item>
        </Breadcrumb>

        <div className="container">
          <PostForm
            initialValues={formPost}
            onSubmit={this.handleSubmit}
            deleteButton={role === 'admin' && deleteButton}
            deleteError={deleteError}
            deleteComment={this.deleteComment}
            modelTags={modelTags}
            createPostTag={this.createPostTag}
            deletePostTag={this.deletePostTag}
          />
        </div>
      </div>
    );
  }
}

export default compose(
  withProps(({ match }) => ({
    postId: match.params.id,
  })),
  withGraphqlData(
    PostDetailQuery,
    (props) => ({ postId: props.postId }),
    'network-only',
  ),
  connect(({ auth: user }) => ({ user }), { push }),
  withApollo,
)(EditPost);
